import { render, staticRenderFns } from "./SupportChat.vue?vue&type=template&id=5db7f780&scoped=true&"
import script from "./SupportChat.vue?vue&type=script&lang=js&"
export * from "./SupportChat.vue?vue&type=script&lang=js&"
import style0 from "./SupportChat.vue?vue&type=style&index=0&id=5db7f780&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db7f780",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5db7f780')) {
      api.createRecord('5db7f780', component.options)
    } else {
      api.reload('5db7f780', component.options)
    }
    module.hot.accept("./SupportChat.vue?vue&type=template&id=5db7f780&scoped=true&", function () {
      api.rerender('5db7f780', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat/SupportChat.vue"
export default component.exports